import * as React from "react";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import VerifyCode from "../pages/auth/verifyCode";
import NewPassword from "../pages/auth/newPassword";
import SingleOrder from "../pages/singleOrder";
import MultiOrder from "../pages/multiOrder";
import MyPackage from "../pages/myPackage";
import Wallet from "../pages/wallet";
import Dashboard from "../pages/dashboard";
import Address from "../pages/dashboard/address";
import ListAddress from "../pages/dashboard/listAddress";
import RequestFactor from "../pages/dashboard/requestFactor";
import Comments from "../pages/dashboard/comments";
import Affiliate from "../pages/dashboard/affiliate";
import Setting from "../pages/dashboard/setting";
import FAQ from "../pages/faq";
import SettingAccount from "../pages/settingAccount";
import Ticket from "../pages/ticket";
import TicketList from "../pages/ticket/list";
import OrderList from "../pages/orderList";
import Packing from "../pages/packing";
import Home from "../pages";
import Rules from "../pages/rules";
import PaymentStatus from "../pages/paymentStatus";
import AboutUS from "../pages/footer/aboutus";
import LoginEDU from "../pages/footer/loginEDU";
import Representation from "../pages/footer/representation";
import Cartoon from "../pages/footer/cartoon";
import Divar from "../pages/divar";
import Track from "../pages/track";
import PageNotFound from "../pages/PageNotFound";
import PageInternalServer from "../pages/PageInternalServer";
import AmnitoRate from "../pages/amnitoRate";
import PostexRate from "../pages/postexRate";
import OrdersOthers from "../pages/ordersOthers";
import {Navigate, Route, Routes, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {setListReview} from "../redux/singleOrder/review/actions";
import {setListBox} from "../redux/multiOrder/infoBox/actions";
import {useDispatch} from "react-redux";
import {setLoading} from "../redux/loading/actions";
import {useSnackbar} from "notistack";
import OrderCancellation from "../pages/orderCancellation";
import WithdrawalRequest from "../pages/wallet/withdrawalRequest";
import AgencyRequest from "../pages/agencyRequest";
import HandleFetchData from "../plugin/HandleFetchData";
import CODRequest from "../pages/codRequest";
import MyRequests from "../pages/dashboard/myRequests";
import {useShowMessageComponent} from "../assets/js/main";
import {Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import Employment from "../pages/employment";


export function RouterComponent() {

  const location = useLocation();
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()

  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = React.useState(true)
  const [loginTryDialog, setLoginTryDialog] = React.useState(false)
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const state = searchParams.get('state')

  const [affiliate, setAffiliate] = React.useState('')


  React.useEffect(() => {
    setAffiliate(searchParams.get('affiliate'))
  }, [])


  React.useEffect(() => {
    setLoggedIn(localStorage.getItem('token'))
    dispatch(setListReview([]))
    dispatch(setListBox([]))

    // location.pathname != '/divar' &&
    searchParams.get('state') && searchParams.get('state') != 'null' && fetchLogin()
  }, [location])

  React.useEffect(() => {
    localStorage.setItem("d-callback", "https://open-platform-redirect.divar.ir/completion")

    if (!sessionStorage.getItem('affiliate')) {
      sessionStorage.setItem('affiliate', searchParams.get('affiliate'))
    } else if (sessionStorage.getItem('affiliate') && sessionStorage.getItem('affiliate') != affiliate) {
      sessionStorage.setItem('affiliate', searchParams.get('affiliate'))
    }

  }, [affiliate])


  const fetchLogin = async () => {
    const token = localStorage.getItem("token")
    const token_id = localStorage.getItem("token-id")
    const code = searchParams.get('code')
    const state = searchParams.get('state')

    if (state && !token) {
      if (!code || token_id != null && state != token_id) {
        setLoginTryDialog(true)
        await localStorage.setItem("token-id", searchParams.get('state'))
        await localStorage.removeItem("token")
        await localStorage.removeItem("info-user")

      } else if (code) {
        await handleLogin()
      } else {
        await showMessageComponent('برای ادامه نیاز به دسترس های شماره تماس و ارسال پیام درچت میباشد', 'warning')
      }
    }
  }

  const handlerAuthentication = () => {
    // if (!loggedIn && state && (!localStorage.getItem("token-id") || localStorage.getItem("token-id") != searchParams.get('state'))) {
    //   handleNotLogin(location?.pathname)
    // } else if (!loggedIn && state && searchParams.get('code') && (localStorage.getItem("token-id") || localStorage.getItem("token-id") != searchParams.get('state'))) {
    //   handleLogin()
    // } else {
    //   return
    // }
    if (!state) {
      return <Login/>
    }
  }


  const handleNotLogin = async (u) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Divar/divarRequestAccess?returnUrl=https://${process.env.REACT_APP_SUBDOMAIN_DIVAR}.postex.ir${u}`, '',
       "application/json", {
         id: searchParams.get('state')
       }, 'postex'
    )

    if (fetch?.isSuccess) {
      window.open(fetch?.data?.url, '_self')
    } else {
      enqueueSnackbar(fetch ? (fetch?.message ? fetch?.message : 'درخواست شما با مشکل مواجه شد') : 'درخواست شما با مشکل مواجه شد', {
        variant: 'error',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    }
    dispatch(setLoading(false))
  }

  const handleLogin = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'POST', '/v1/Customer/loginByCode', '',
       "application/json", {
         code: searchParams.get('code'),
         id: searchParams.get('state')
       }, 'postex'
    )

    if (fetch && fetch?.isSuccess) {
      await localStorage.setItem('token', fetch?.data?.token)
      localStorage.setItem("token-id", searchParams.get('state'))
      localStorage.setItem('info-user', JSON.stringify({
        "FullName": (fetch?.data?.firstName || fetch?.data?.lastName) ? fetch?.data?.firstName + ' ' + fetch?.data?.lastName : null,
        "Email": fetch?.data?.email,
        "Mobile": fetch?.data?.username,
        "IsAgent": fetch?.data?.isAgent,
      }))
    } else if (fetch && !fetch?.isSuccess) {
      await showMessageComponent('مجددا وارد شوید', 'error')
    } else if (fetch && fetch?.data?.StatusCode === 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    }
    // setResApi(fetch)
    dispatch(setLoading(false))
  }

  return (
     <>
       <Routes>
         <Route path="/" element={
           window.location.search ? <Navigate to={{pathname: `/tracking${window.location.search}`, search: location?.search}}/> :
              <Navigate to={{pathname: '/tracking', search: location?.search}}/>
         }/>
         <Route path="/divar" element={<Divar/>} exact/>
         {/*<Route path="/aplanding" element={<APLanding/>} exact/>*/}
         {/*<Route path="/tracking" element={<PostexLanding/>} exact/>*/}
         <Route path="/tracking" element={<Home/>} exact/>
         <Route path="/track/:code" element={<Track/>} exact/>
         <Route path="/divar/track/:code" element={<Track/>} exact/>
         <Route path="/auth/login" element={<Login/>} exact/>
         <Route path="/auth/register" element={<Register/>} exact/>
         <Route path="/auth/verifyCode" element={<VerifyCode/>} exact/>
         <Route path="/auth/newPassword" element={<NewPassword/>} exact/>
         {/*<Route path="/singleOrder" element={<SingleOrder/>} onEnter={requireAuth}/>*/}
         <Route path="/singleOrder" element={loggedIn ? <SingleOrder/> : handlerAuthentication()} exact/>
         <Route path="/divar/singleOrder" element={<SingleOrder/>}/>
         <Route path="/multiOrder" element={loggedIn ? <MultiOrder/> : handlerAuthentication()} exact/>
         <Route path="/myPackage" element={<MyPackage/>} exact/>
         <Route path="/wallet" element={loggedIn ? <Wallet/> : handlerAuthentication()} exact/>
         <Route path="/divar/wallet" element={<Wallet/>} exact/>
         <Route path="/wallet/withdrawalRequest" element={<WithdrawalRequest/>} exact/>
         <Route path="dashboard" element={loggedIn ? <Dashboard/> : handlerAuthentication()} exact/>
         <Route path="dashboard/address" element={loggedIn ? <Address/> : handlerAuthentication()} exact/>
         <Route path="dashboard/listAddress" element={loggedIn ? <ListAddress/> : handlerAuthentication()} exact/>
         <Route path="dashboard/comments" element={loggedIn ? <Comments/> : handlerAuthentication()} exact/>
         <Route path="dashboard/presentation" element={<Affiliate/>} exact/>
         <Route path="dashboard/requestFactor" element={<RequestFactor/>} exact/>
         <Route path="dashboard/setting" element={<Setting/>} exact/>
         <Route path="/faq" element={<FAQ/>} exact/>
         <Route path="/settingAccount" element={loggedIn ? <SettingAccount/> : handlerAuthentication()} exact/>
         <Route path="/support" element={loggedIn ? <Ticket/> : handlerAuthentication()} exact/>
         <Route path="/support/list" element={loggedIn ? <TicketList/> : handlerAuthentication()} exact/>
         <Route path="/orderList" element={loggedIn ? <OrderList/> : handlerAuthentication()} exact/>
         <Route path="/ordersOthers" element={loggedIn ? <OrdersOthers/> : handlerAuthentication()} exact/>
         <Route path="/divar/orderList" element={<OrderList/>}/>
         <Route path="/divar/ordersOthers" element={<OrdersOthers/>}/>
         <Route path="/packing" element={<Packing/>} exact/>
         <Route path="/rules" element={<Rules/>} exact/>
         <Route path="/divar/rules" element={<Rules/>} exact/>
         <Route path="/paymentStatus" element={<PaymentStatus/>} exact/>

         <Route path="/aboutus" element={<AboutUS/>} exact/>
         <Route path="/loginedu" element={<LoginEDU/>} exact/>
         <Route path="/representation" element={<Representation/>} exact/>
         <Route path="/cartoon" element={<Cartoon/>} exact/>
         <Route path="/amnitoRate" element={<AmnitoRate/>} exact/>
         <Route path="/postexRate" element={<PostexRate/>} exact/>
         <Route path="/orderCancellation" element={<OrderCancellation/>} exact/>
         <Route path="/agencyRequest" element={<AgencyRequest/>} exact/>
         <Route path="/codRequest" element={<CODRequest/>} exact/>
         <Route path="/myRequests" element={<MyRequests/>} exact/>
         <Route path="/employment" element={<Employment/>} exact/>

         <Route path="/pageNotFound" element={<PageNotFound/>} exact/>
         <Route path="/pageInternalServer" element={<PageInternalServer/>} exact/>

         <Route path="*" element={<Navigate to={{pathname: '/pageNotFound', search: location?.search}}/>} exact/>

       </Routes>

       <Dialog
          open={loginTryDialog}
          onClose={() => setLoginTryDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="dialog-rules"
       >
         <DialogContent>
           <DialogContentText id="alert-dialog-description">
             <h6>
               برای ادامه نیاز به دسترس های شماره تماس و ارسال پیام درچت میباشد
             </h6>
           </DialogContentText>
         </DialogContent>
         <DialogActions>
             <div className="btnGroup_yellow flex-row mb-0">
               <button className="btnEmpty mb-2" onClick={() => {
                 setLoginTryDialog(false)
                 if(location.pathname != '/divar') {
                   navigate({
                     pathname: "/divar",
                     search: location?.search
                   });
                 }
               }}>
                 <span>انصراف</span>
               </button>
               <button className="btnFill mb-0" onClick={() => handleNotLogin(location?.pathname)}>
                 <span>ادامه</span>
               </button>
             </div>
         </DialogActions>
       </Dialog>
     </>
  )
}
